import { createAnatomy as a } from "../../anatomy/dist/index.mjs";
import { createScope as n, queryAll as g } from "../../dom-query/dist/index.mjs";
import { createProps as r } from "../../types/dist/index.mjs";
var I = a("radio-group").parts(
  "root",
  "label",
  "item",
  "itemText",
  "itemControl",
  "indicator"
);
I.build();
var d = n({
  getRootId: (t) => {
    var e;
    return ((e = t.ids) == null ? void 0 : e.root) ?? `radio-group:${t.id}`;
  },
  getLabelId: (t) => {
    var e;
    return ((e = t.ids) == null ? void 0 : e.label) ?? `radio-group:${t.id}:label`;
  },
  getItemId: (t, e) => {
    var o, i;
    return ((i = (o = t.ids) == null ? void 0 : o.item) == null ? void 0 : i.call(o, e)) ?? `radio-group:${t.id}:radio:${e}`;
  },
  getItemHiddenInputId: (t, e) => {
    var o, i;
    return ((i = (o = t.ids) == null ? void 0 : o.itemHiddenInput) == null ? void 0 : i.call(o, e)) ?? `radio-group:${t.id}:radio:input:${e}`;
  },
  getItemControlId: (t, e) => {
    var o, i;
    return ((i = (o = t.ids) == null ? void 0 : o.itemControl) == null ? void 0 : i.call(o, e)) ?? `radio-group:${t.id}:radio:control:${e}`;
  },
  getItemLabelId: (t, e) => {
    var o, i;
    return ((i = (o = t.ids) == null ? void 0 : o.itemLabel) == null ? void 0 : i.call(o, e)) ?? `radio-group:${t.id}:radio:label:${e}`;
  },
  getIndicatorId: (t) => {
    var e;
    return ((e = t.ids) == null ? void 0 : e.indicator) ?? `radio-group:${t.id}:indicator`;
  },
  getRootEl: (t) => d.getById(t, d.getRootId(t)),
  getItemHiddenInputEl: (t, e) => d.getById(t, d.getItemHiddenInputId(t, e)),
  getIndicatorEl: (t) => d.getById(t, d.getIndicatorId(t)),
  getFirstEnabledInputEl: (t) => {
    var e;
    return (e = d.getRootEl(t)) == null ? void 0 : e.querySelector("input:not(:disabled)");
  },
  getFirstEnabledAndCheckedInputEl: (t) => {
    var e;
    return (e = d.getRootEl(t)) == null ? void 0 : e.querySelector("input:not(:disabled):checked");
  },
  getInputEls: (t) => {
    const o = `input[type=radio][data-ownedby='${CSS.escape(d.getRootId(t))}']:not([disabled])`;
    return g(d.getRootEl(t), o);
  },
  getActiveRadioEl: (t) => {
    if (t.value)
      return d.getById(t, d.getItemId(t, t.value));
  },
  getOffsetRect: (t) => ({
    left: (t == null ? void 0 : t.offsetLeft) ?? 0,
    top: (t == null ? void 0 : t.offsetTop) ?? 0,
    width: (t == null ? void 0 : t.offsetWidth) ?? 0,
    height: (t == null ? void 0 : t.offsetHeight) ?? 0
  }),
  getRectById: (t, e) => {
    const o = d.getById(t, d.getItemId(t, e));
    if (o)
      return d.resolveRect(d.getOffsetRect(o));
  },
  resolveRect: (t) => ({
    width: `${t.width}px`,
    height: `${t.height}px`,
    left: `${t.left}px`,
    top: `${t.top}px`
  })
});
r()([
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "name",
  "onValueChange",
  "orientation",
  "readOnly",
  "value"
]);
r()(["value", "disabled", "invalid"]);
export {
  I as anatomy
};
